import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { combineLatest } from 'rxjs';
import { getPackageForChart } from '../../google-charts-helper';
import { GoogleChartType } from '../../google-charts-type';
import { GoogleChartBaseComponent } from '../chart-base.component';
declare const google: any;
@Component({
  selector: 'app-google-pie-chart',
  templateUrl: './google-pie-chart.component.html',
  styleUrls: ['./google-pie-chart.component.scss'],
})
export class GooglePieChartBaseComponent
  extends GoogleChartBaseComponent
  implements OnInit
{
  @ViewChild('chartContainer', { read: ElementRef })
  private containerEl: ElementRef<HTMLElement>;
  chartType = GoogleChartType.PieChart;

  @Input()
  set data(val: Array<Array<any>>) {
    if (val && val.length > 0) {
      this.chartData.next(val);
    }
  }

  @Input()
  set options(val: Record<string, any>) {
    if (val) {
      this.chartOptions.next(val);
    }
  }

  ngOnInit(): void {
    const chartPackage = getPackageForChart(this.chartType);

    combineLatest([
      this.chartData$,
      this.chartOptions$,
      this.loadChartPackage(chartPackage),
    ]).subscribe(([data, options]) => {
      if (data && options) {
        this.chart = new google.visualization.PieChart(
          this.containerEl.nativeElement
        );
        this.drawChart(data, options);
      }
    });
  }
}
